import axios from 'axios'
import { EventDailyInsightModel, MarketInsightStatusModel, MarketInsightLatestModel } from './_models'

const API_URL = process.env.REACT_APP_API_URL
const DASHBOARD_EVENT_DAILY_INSIGHT = `${API_URL}/dashboard/event-daily-insight`
const DASHBOARD_MARKET_INSIGHT_STATUS = `${API_URL}/dashboard/market-insight/status`
const DASHBOARD_MARKET_INSIGHT_LATEST = `${API_URL}/dashboard/market-insight/latest`

export function getEventDailyInsight() {
    return axios.get<EventDailyInsightModel | null>(DASHBOARD_EVENT_DAILY_INSIGHT)
}

export function getMarketInsightStatus() {
    return axios.get<MarketInsightStatusModel>(DASHBOARD_MARKET_INSIGHT_STATUS)
}

export function getMarketInsightLatest() {
    return axios.get<MarketInsightLatestModel>(DASHBOARD_MARKET_INSIGHT_LATEST)
}
